import { FormControl, InputAdornment, TextField } from '@mui/material';

import MLCustomIcon from '../CustomIcon';

import './SearchInput.module.scss';

export const MLSearchInput = ({
  classList,
  placeholderText,
  setSearchChange,
  programName = '',
  searchValue = '',
}) => {
  const handleChange = (event) => {
    if (setSearchChange) {
      setSearchChange(event.target.value);
    }
  };

  return (
    <FormControl className={`input-wrap   ${classList} `}>
      <TextField
        size="small"
        placeholder={placeholderText}
        variant="outlined"
        onChange={handleChange}
        value={searchValue}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <MLCustomIcon
                stroke="var(--Grey-Scale-Grey-60)"
                iconName="Search"
              />
            </InputAdornment>
          ),
        }}
        sx={{
          '& .MuiInputBase-input::placeholder': {
            color: 'var(--Grey-Scale-Grey-80)',
          },
        }}
      />
    </FormControl>
  );
};
